import { round } from 'app/utils/number';

const getFormWinrate = (opponentId: number, form: Encounter[]): number =>
  round(
    (form.filter(encounter => encounter.winner_id === opponentId).length / form.length) * 100,
    0
  ) || 0;

export { getFormWinrate };
